import React, { useState, useEffect } from "react";
import HomePageTeachers from "./HomePageTeachers";
import HomePageUsers from "./HomePageUsers";
import HomePageSchool from "./HomePageSchool";
import Menu from "./components/Menu";
import background1 from "../svg/unicorn.jpeg";
import background2 from "../svg/background2.png";
import backgroundSchool from "../svg/backgroundSchool.png";
import Footer from "./components/Footer";
import { useTranslation } from "react-i18next";
import PaymentSuccessful from "./PaymentSuccessful";
import PaymentNotSuccessful from "./PaymentNotSuccessful";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import Tickets from "./Tickets";

const MainView = () => {
  const [changeVersionHandler, setchangeVersionHandler] = useState(true);
  const [,i18n] = useTranslation("global");

  let { pathname } = useLocation();
  let showFooter = true;

  useEffect(() => {
    if (pathname === "/academic") {
      setchangeVersionHandler("academic");
    }
    if (pathname === "/school") {
      setchangeVersionHandler("school");
    }
    if (pathname === "/") {
      setchangeVersionHandler("users");
    }
  }, [pathname]);

  if (pathname === "/tickets") {
    showFooter = false;
  }

  let background = {
    backgroundImage: `url(${background1})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundPositionY: "top",
    backgroundSize: "100% auto", 
  };
  let height = " bg-scroll bg-black";

  if (changeVersionHandler === "academic") {
    background = {
      backgroundImage: `url(${background2})`,
      backgroundRepeat: "no-repeat",
    };
    height = "py-0 ";
  } else if (changeVersionHandler === "school") {
    background = {
    backgroundImage: `url(${backgroundSchool})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center top",
    backgroundSize: "cover",
  };
  height = "h-screen";
  }
  return (
    <div id="home" style={background} className={height}>
      <Menu
        changeVersionHandler={changeVersionHandler}
        ticketsShow={!showFooter}
      />
      <Routes>
        <Route path="/" element={<HomePageUsers />} />
        <Route path="/academic" element={<HomePageTeachers />} />
        <Route path="/school" element={<HomePageSchool />} />
        <Route path="/tickets" element={<Tickets language={i18n.language}/>} />
        <Route path="/tickets/successful" element={<PaymentSuccessful />} />
        <Route
          path="/tickets/unsuccessful"
          element={<PaymentNotSuccessful />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {showFooter && <Footer version={changeVersionHandler} />}
    </div>
  );
};

export default MainView;
